module.exports = __webpack_public_path__ + "a55bd41e4f319b6a8da859cac073af43.svg";